import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import LeftSidebar from 'components/LeftSidebar/LeftSidebar';
import Header from 'components/Header/Header';
import Map from 'components/Map/Map';
import Modal from 'components/Modal/Modal';
import Instructions from 'components/Content/Instructions';
import './App.scss';
import { projects } from 'components/constants';

ReactGA.initialize('G-3NZZHCPW7E');
// Main:    G-3NZZHCPW7E
// Dingley: G-DYLXH5CP60
// Dev:     G-VJRJFGGFDT
// FB:      G-5FZK05KX66

const App = () => {
  const [activeMenu, setActiveMenu] = useState<string>('about');
  const [projectSelected, setProjectSelected] = useState<any>({
    project: '',
    event: '',
  });
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const [centerMap, setCenterMap] = useState<[number, number]>([0, 0]);
  const [resetClicked, setResetClicked] = useState<number>(0);

  useEffect(() => {
    // ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
      title: 'Homepage',
    });
  }, []);

  return (
    <div className="sew-interactive-map">
      <Header
        setCenterMap={(centerLatLng: [number, number]) => {
          setCenterMap(centerLatLng);
        }}
        resetClicked={resetClicked}
        setResetClicked={(reset) => {
          setResetClicked(reset);
          setProjectSelected('');
          setActiveMenu('');
        }}
      />
      <div className="main-content">
        <LeftSidebar
          activeMenu={activeMenu}
          setActiveMenu={(menu) => {
            setActiveMenu(menu);
          }}
          projectSelected={projectSelected}
          setProjectSelected={(project) =>
            setProjectSelected({
              project,
              event: 'leftMenu',
            })
          }
        />
        <div className="map-content">
          <Map
            projectSelected={projectSelected}
            centerMap={centerMap}
            onClickMarker={(project: string) => {
              setProjectSelected({
                project,
                event: 'map',
              });

              const currProject = projects.find((p) => p.value === project);
              setActiveMenu(currProject?.category || 'water-renewals');
              ReactGA.event({
                category: `Map - ${currProject?.category?.replaceAll(
                  '-',
                  ' '
                )} (${currProject?.color})`,
                action: 'Expand tooltip',
                label: `BOX: ${currProject?.title}`,
              });
            }}
            onClickLine={(project: string) => {
              setProjectSelected({
                project,
                event: 'leftMenu',
              });
              const currProject = projects.find((p) => p.value === project);
              setActiveMenu(currProject?.category || 'water-renewals');
              ReactGA.event({
                category: `Map - ${currProject?.category?.replace('-', ' ')} (${
                  currProject?.color
                })`,
                action: 'Expand tooltip',
                label: `PIPE: ${currProject?.title}`,
              });
            }}
            resetClicked={resetClicked}
          />
        </div>
      </div>
      <Modal isOpen={isModalOpen} closeModal={() => setIsModalOpen(false)}>
        <Instructions />
      </Modal>
    </div>
  );
};

export default App;
